import { Popover, Typography } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { handleTypeText } from "../helper";
import Acent from "components/Acent";
// import { convertToHtml } from "utils/config/reference";
import { PlayCircleOutlined } from "@ant-design/icons";
import SentryWrap from "components/Sentry";
import CloseIconss from "../../../utils/assets/images/closes.svg";
import WSCorrect from "../../../utils/assets/images/wsCorrect.svg";
import { formatTextForRemoveUnderScore } from "features/forms/assignment/fillInBlanks/helper";

const FillInTheBlankType = ({
  currentData,
  activeIndex,
  handleSubmit,
  selectAnswer,
  setSelectAnswer,
  playSound,
  timeSpent,
  consecutiveCorrect,
  setConsecutiveCorrect,
  isCorrect,
  setLoading,
  buttonClickSound,
  preloadedAssets,
  modernImage
}) => {
  const [disabled, setDisabled] = useState(false);
  const [isAnswerSubmitted, setIsAnswerSubmitted] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const inputRef = useRef(null);
  const [userAnswer, setUserAnswer] = useState("");
  const {
    imageUrl = "",
    inAnimation,
    outAnimation,
    inSound,
  } = useMemo(() => {
    if (Array.isArray(modernImage) && modernImage.length > 0) {
      const safeIndex = isCorrect % modernImage.length;
      const shuffledImages = [...modernImage];
      for (let i = shuffledImages.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledImages[i], shuffledImages[j]] = [
          shuffledImages[j],
          shuffledImages[i],
        ];
      }
      return shuffledImages[safeIndex];
    }
    return {};
  }, [isCorrect, modernImage]);
  const [isCorrectHighlight, setIsCorrectHighlight] = useState(false);
  const checkHighlighted =
    currentData?.highlightWords?.map((h) => h?.text?.trim()).join(" ") || [];
  const isCorrecHighLight = currentData?.highlightWords
    ? userAnswer?.trim() ===  formatTextForRemoveUnderScore(checkHighlighted)
    : userAnswer?.trim() === currentData?.correct_answer?.trim();

  useEffect(() => {
    setUserAnswer("");
  }, [activeIndex]);

  const handleInputAcentChange = (e) => {
    if (e) {
      setUserAnswer(e);
      setSelectAnswer(e);
    }
  };

  const handleAnswer = (e) => {
    const value = e.target.value;
    setUserAnswer(value);
    setSelectAnswer(value);
  };

  const playInSound = (soundFile) => {
    if (soundFile) {
      const audio = preloadedAssets?.sounds[soundFile];
      audio.loop = false;
      audio.playbackRate = 1.8;
      audio.play();
    }
  };

  const onSubmit = (e) => {
    setLoading({ type: "submitLesson", value: true });
    e.preventDefault();
    if (disabled) return;

    // setSelectedAnswer(userAnswer);
    setIsAnswerSubmitted(true);
    
    if (isCorrecHighLight) {
      playInSound(inSound);
      setIsCorrectHighlight(true);
      setFadeIn(true);
    }
    setDisabled(true);
    setTimeout(() => {
      handleSubmit();
      setFadeIn(false);
      // setSelectedAnswer(null);
      setIsAnswerSubmitted(false);
      setDisabled(false);
      setIsCorrectHighlight(false);
      setLoading({ type: "submitLesson", value: false });
    }, 3500);
  };

  const icon = isAnswerSubmitted ? (
    isCorrecHighLight ? (
      <img
        style={{
          top:"0px",
          position: "absolute",
          right: "-25px",
          width: "72px",
        }}
        src={WSCorrect}
        alt="Correct answer"
        title="Correct answer"
      />
    ) : (
      <img
        style={{
          top:"0px",
          position: "absolute",
          right: "-25px",
          width: "72px",
        }}
        src={CloseIconss}
        alt="Incorrect answer"
        title="Incorrect answer"
      />
    )
  ) : null;


  return (
    <>
      <Popover
        placement="top"
        content={() => {
          return (
            <div className="flex flex-col gap-10px">
              <Typography.Text strong>
                Detail: {currentData?.tenseOption?.detail}
              </Typography.Text>
              <Typography.Text strong>Example:</Typography.Text>
              {currentData?.tenseOption?.examples?.map((element, index) => (
                <Typography.Text key={index}>- {element}</Typography.Text>
              ))}
            </div>
          );
        }}
        title="Tense Info"
        trigger="hover"
        overlayStyle={{
          zIndex: 4000,
        }}
      >
        <TranslateText uppercase={true}>
          {currentData?.tenseOption?.type}
        </TranslateText>
      </Popover>

      <Acent
        inputRef={inputRef}
        setValue={(e) => handleInputAcentChange(e)}
        style={{
          marginBottom: 5,
          display: "flex",
          justifyContent: "flex-end",
        }}
      />
      <QuestionText className="flex items-center">
        {currentData?.question_audio &&
          currentData?.question_audio?.length > 0 && (
            <div
              style={{
                position: "relative",
                display: "inline-block",
                height: 60,
              }}
            >
              <img
                onClick={playSound}
                style={{ height: 60, cursor: "pointer" }}
                src="/assets/images/femaleVoice.svg"
                alt=""
                title=""
              />
              <PlayCircleOutlined
                onClick={playSound}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontSize: 22,
                  color: "#fff",
                  cursor: "pointer",
                }}
              />
            </div>
          )}
        <div className="flex items-center gap-10px">
          <FillInTheBlank
            questionData={currentData}
            handleAnswer={handleAnswer}
            userAnswer={userAnswer}
            inputRef={inputRef}
            timeSpent={timeSpent}
          />
        </div>
        {fadeIn && (
          <AnimationContainer
            className={`soccerAnimatedImg animate__animated ${
              fadeIn ? inAnimation : outAnimation
            }`}
          >
            {/* <div className="soccerAnimatedImg animate__animated"> */}
            <img src={imageUrl} alt="" className="crop-img-score" />
          </AnimationContainer>
        )}
      </QuestionText>
      <div className="w-full text-center 12" style={{ marginBottom: "10px" }}>
        <Typography.Text strong color="#1b85e5" className="question-type-text">
          {handleTypeText(currentData?.type)}
        </Typography.Text>
      </div>

      <AnimatedStyledButton
        className="checkStyleBtn"
        onClick={(e) => {
          buttonClickSound(isCorrecHighLight);
          onSubmit(e);
        }}
        style={{
          cursor:
            selectAnswer?.length === 0 || timeSpent !== 0
              ? "not-allowed"
              : "pointer",
          backgroundColor:
            isCorrectHighlight || (isAnswerSubmitted && isCorrecHighLight)
              ? "#00d54f" // Correct
              : isAnswerSubmitted && !isCorrecHighLight
              ? "#f9b8d7" // Wrong
              : "#1b85e5", // Default
          color: isAnswerSubmitted && !isCorrecHighLight ? "black" : "white",
        }}
        disabled={timeSpent !== 0 || selectAnswer?.length === 0}
      >
        Check
        {icon}
      </AnimatedStyledButton>
    </>
  );
};

export default FillInTheBlankType;

const AnimatedStyledButton = styled.button`
  position: relative;
  padding: 10px 24px;
  font-size: 16px;
  border-radius: 20px !important;
  text-transform: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: none;
  width: 100%;
  min-height: 45px;
  margin-bottom: 20px;
  transition: background-color 0.3s ease, color 0.3s ease;
`;

const FillInTheBlank = ({
  questionData,
  userAnswer,
  inputRef,
  handleAnswer,
  timeSpent,
}) => {
  // Function to process the question text to handle parenthesized words
  const processQuestionText = (text, highlights) => {
    try {
      let result = [];
      let currentIndex = 0;

      // Find all parenthesized words
      const parenthesisRegex = /\(([^)]+)\)/g;
      let parenthesisMatch;
      // let modifiedText = text;
      let tooltipWords = [];

      // Extract all parenthesized words and their positions
      while ((parenthesisMatch = parenthesisRegex.exec(text)) !== null) {
        tooltipWords.push({
          word: parenthesisMatch[1],
          start: parenthesisMatch.index,
          end: parenthesisMatch.index + parenthesisMatch[0].length,
        });
      }

      // Process text with highlights and tooltips
      if (highlights) {
        highlights.forEach((highlight) => {
          if (highlight.start > currentIndex) {
            // Add text before the highlight
            // const beforeText = text.slice(currentIndex, highlight.start);

            // Check if there are any tooltips in this segment
            let lastTooltipEnd = currentIndex;
            tooltipWords.forEach((tooltip) => {
              if (
                tooltip.start >= lastTooltipEnd &&
                tooltip.end <= highlight.start
              ) {
                // Add text before tooltip
                if (tooltip.start > lastTooltipEnd) {
                  result.push(text.slice(lastTooltipEnd, tooltip.start));
                }

                // Add tooltip component
                result.push(
                  <span
                    key={`tooltip-${tooltip.start}`}
                    className="tooltip-word"
                    title={`Infinitive verb form`}
                    style={{
                      textDecoration: "underline",
                      cursor: "help",
                      borderBottom: "1px dotted #888",
                    }}
                  >
                    ({tooltip.word})
                  </span>
                );

                lastTooltipEnd = tooltip.end;
              }
            });

            // Add remaining text before the highlight
            if (lastTooltipEnd < highlight.start) {
              result.push(text.slice(lastTooltipEnd, highlight.start));
            }
          }

          // Add the input field for the blank
          result.push(
            <StyledInput
              key="input-field"
              type="text"
              value={userAnswer}
              onChange={handleAnswer}
              ref={inputRef}
              disabled={timeSpent !== 0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && userAnswer?.trim().length > 0 && timeSpent === 0) {
                  e.preventDefault();
                  const submitButton = document.querySelector('.checkStyleBtn');
                  if (submitButton) {
                    submitButton.click();
                  }
                }
              }}
            />
          );

          // Update the current index to after the highlighted word
          currentIndex = highlight.end;
        });
      }

      // Add any remaining text after the last highlight
      if (currentIndex < text.length) {
        // const remainingText = text.slice(currentIndex);

        // Check if there are any tooltips in the remaining text
        let lastTooltipEnd = currentIndex;
        tooltipWords.forEach((tooltip) => {
          if (
            tooltip.start >= lastTooltipEnd &&
            tooltip.start >= currentIndex
          ) {
            // Add text before tooltip
            if (tooltip.start > lastTooltipEnd) {
              result.push(text.slice(lastTooltipEnd, tooltip.start));
            }

            // Add tooltip component
            result.push(
              <VerbSpan>({tooltip.word || ""})</VerbSpan>
            );

            lastTooltipEnd = tooltip.end;
          }
        });

        // Add remaining text after last tooltip
        if (lastTooltipEnd < text.length) {
          result.push(text.slice(lastTooltipEnd));
        }
      }

      return result;
    } catch (error) {
      console.error("Error processing question text:", error);
      return text;
    }
  };

  const processedText = processQuestionText(
    questionData?.question,
    questionData?.highlightWords
  );

  return (
    <SentryWrap>
      <div className="fill-blank-question">{processedText}</div>
    </SentryWrap>
  );
};

const AnimationContainer = styled.div`
  position: absolute;
  @media Screen and (max-width: 1366px) {
    top: 35%;
    left: 20%;
  }
  @media Screen and (max-width: 600px) {
    img {
      width: 180%;
    }
  }
`;

const VerbSpan = styled.span`
  color: #1b85e5;
  font-weight: bold;
  text-decoration: underline;
  &:hover {
    color: #0056b3;
  }
`;

const StyledInput = styled.input`
  border: none;
  border-bottom: 6px solid rgb(218, 114, 24);
  padding: 5px;
  font-size: 16px;
  color: black;
  width: 100px;
  background: transparent;
  -webkit-transform: translate(0px) scale(1);
  -ms-transform: translate(0px) scale(1);
  transform: translate(0px) scale(1);
  outline: none;
  border-radius: 5px;
  font-weight: 700;
  font-size: 19px;
`;

const QuestionText = styled.p`
  font-size: 16px;
  color: #333;
`;

const TranslateText = styled.p`
  font-size: 16px;
  color: darkblue;
  font-weight: bold;
  text-align: center;
  text-transform: ${(p) => (p?.uppercase ? "uppercase" : "")};
`;

// const StyledButton = styled.button`
//   background-color: ${(p) =>
//     p.backgroundColor
//       ? p.backgroundColor
//       : p.isCorrect
//       ? "rgb(180, 255, 219) !important"
//       : "#f9b8d7 !important"};
//   padding: 10px 24px;
//   font-size: 16px;
//   border-radius: 20px;
//   color: ${(p) => (p.color ? p.color : "black")};
//   text-transform: none;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//   border: none;
//   width: 100%;
//   min-height: 45px;
//   border-radius: 20px !important;
//   margin-bottom: 20px;
//   // &:hover {
//   //   background-color: #a0e4a0;
//   // }
//   &:disabled {
//     cursor: not-allowed !important;
//     background-color: #f0f0f0;
//   }
// `;
